import React, { useState, useEffect, useCallback } from "react";
import LoginLeftBg from "../../components/loginLeftBg";
import Button from "../../components/button";
import Step1 from "./step1";
import Step2 from "./step2";
import RightArrowIcon from "../../icons/rightArrow";
import useMediaQuery from "../../hooks/useMediaQuery";
import { useAuth } from "../../hooks/useAuth";
import { jwtDecode } from "jwt-decode";
import axios from "../../api/axios";
import SuccessImg from "../../assets/images/successfully.png";
import LogoImg from "../../assets/images/logo.png";
import styles from "./style.module.css";
import { useNavigate } from "react-router-dom";

const SignUp = () => {
  const isMobile = useMediaQuery("(max-width: 768px)");
  const { setAuth, persist, setPersist } = useAuth();
  const [success, setSuccess] = useState(false);
  const [activeStep, setActiveStep] = useState(1);
  const [emailID, setEmailID] = useState("");
  const [step1FormData, setStep1FormData] = useState({});
  const [loading, setLoading] = useState(false);
  const [responseData, setResponseData] = useState({});
  const [errorMessage, setErrorMessage] = useState("");
  let navigate = useNavigate();

  const onStep1FormSubmit = (data) => {
    setStep1FormData(data);
    setEmailID(data.email);
    handleRegister(data);
  };

  // const handleRegister = useCallback(async (data) => {
  //   setErrorMessage("");
  //   try {
  //     setLoading(true);
  //     let url = `auth/register`;
  //     let options = {
  //       method: "POST",
  //       url,
  //       data,
  //       headers: {
  //         "Content-Type": "application/json",
  //       },
  //       withCredentials: true,
  //     };
  //     await axios(options)
  //       .then((response) => {
  //         if (response.data.status === 1) {
  //           setActiveStep(2);
  //         }
  //         setLoading(false);
  //       })
  //       .catch((err) => {
  //         if (err.response) {
  //           setLoading(false);
  //           setErrorMessage(err.response.data.message);
  //         }
  //       });
  //   } catch (error) {
  //     setLoading(false);
  //   }
  // }, []);


  const handleRegister = useCallback(async (data) => {
    setErrorMessage("");
    try {
      setLoading(true);
      let url = `auth/register`;
      let options = {
        method: "POST",
        url,
        data,
        headers: {
          "Content-Type": "application/json",
        },
        withCredentials: true,
      };
      await axios(options)
        .then((response) => {
          if (response.data.status === 1) {
            setActiveStep(2);
          }
          else if (response.data.status === 2 || response.data.status === 3) {
            const token = response.data.accessToken;
            let decoded = jwtDecode(token);

            setAuth({
              id: decoded.id,
              currentCar: decoded.currentCar,
              monitorBy: decoded.monitorBy,
              token: token,
              multipleCars: decoded.multipleCars,
              ndaAccepted: decoded.ndaAccepted,
              paymentWindow: decoded.paymentWindow,
              trialDays: decoded.trialDays,
              membershipAmount: decoded.membershipAmount,
              membership: decoded.membership,
            });

            localStorage.setItem("persist", true);
            localStorage.setItem("tk", token);
            localStorage.setItem("rtkn", response.data.refreshToken);
            setPersist(true);

            navigate("/");
          }
          setLoading(false);
        })
        .catch((err) => {
          if (err.response) {
            setLoading(false);
            setErrorMessage(err.response.data.message);
          }
        });
    } catch (error) {
      setLoading(false);
    }
  }, [navigate, setAuth, setPersist]);

  const onStep2FormSubmit = (data) => {
    let tempData = {
      email: emailID,
      verificationCode: data,
    };
    handleVerifyEmail(tempData);
  };

  const handleVerifyEmail = useCallback(async (data) => {
    try {
      setErrorMessage("");
      setLoading(true);
      let url = `auth/verify-email`;
      let options = {
        method: "POST",
        url,
        data,
        headers: {
          "Content-Type": "application/json",
        },
        withCredentials: true,
      };
      await axios(options)
        .then((response) => {
          if (response.data.status === 1) {
            setResponseData(response.data);
            setSuccess(true);
          }
          setLoading(false);
        })
        .catch((err) => {
          if (err.response) {
            setLoading(false);
            setErrorMessage(err.response.data.message);
          }
        });
    } catch (error) {
      setLoading(false);
    } // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onResend = () => {
    let tempData = {
      email: emailID,
    };
    handleResendCode(tempData);
  };
  const handleResendCode = useCallback(async (data) => {
    try {
      setErrorMessage("");
      setLoading(true);
      let url = `auth/resend-regcode`;
      let options = {
        method: "POST",
        url,
        data,
        headers: {
          "Content-Type": "application/json",
        },
        withCredentials: true,
      };
      await axios(options)
        .then((response) => {
          if (response.data.status === 1) {
          }
          setLoading(false);
        })
        .catch((err) => {
          if (err.response) {
            setLoading(false);
            setErrorMessage(err.response.data.message);
          }
        });
    } catch (error) {
      setLoading(false);
    } // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleLogin = () => {
    let decoded = jwtDecode(responseData.accessToken);
    const token = responseData.accessToken;
    setAuth({
      id: decoded.id,
      currentCar: decoded.currentCar,
      monitorBy: decoded.monitorBy,
      token: token,
      multipleCars: decoded.multipleCars,
      ndaAccepted: decoded.ndaAccepted,
      paymentWindow: decoded.paymentWindow,
      trialDays: decoded.trialDays,
      membershipAmount: decoded.membershipAmount,
      membership: decoded.membership,
    });
    localStorage.setItem("persist", true);
    localStorage.setItem("tk", token);
    localStorage.setItem("rtkn", responseData.refreshToken);
    setPersist(true);
  };



  useEffect(() => {
    setSuccess(false);
  }, []);

  useEffect(() => {
    localStorage.setItem("persist", persist);
  }, [persist]);

  return (
    <div className={styles.main}>
      {isMobile && (
        <div className={styles.main_logo}>
          <img src={LogoImg} alt="Logo" />
        </div>
      )}
      {success ? (
        <div className={styles.main_success}>
          <div className={styles.main_success_content}>
            <img src={SuccessImg} alt="Success" />
            <div className={styles.main_success_title}>
              You are successfully registered!
            </div>
            <div className={styles.main_success_btn}>
              <Button
                onClick={handleLogin}
                title="Let’s Start"
                endIcon={<RightArrowIcon />}
              />
            </div>
          </div>
        </div>
      ) : (
        <div className={styles.main_container}>
          {!isMobile && (
            <div className={styles.main_left}>
              <LoginLeftBg />
            </div>
          )}
          <div className={styles.main_right}>
            <div className={styles.form_container}>
              {activeStep === 1 && (
                <Step1
                  formData={step1FormData}
                  onFormSubmit={onStep1FormSubmit}
                  loading={loading}
                  errorMessage={errorMessage}
                />
              )}
              {activeStep === 2 && (
                <Step2
                  onFormSubmit={onStep2FormSubmit}
                  onResendClick={onResend}
                  loading={loading}
                  errorMessage={errorMessage}
                />
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SignUp;
